<template>
  <div style="margin-top:20px">
    <el-form ref="form" label-width="80px" :model="form">
      <el-row>
        <el-form-item label="名称" style="margin-right:15px">
          <el-input v-model="form.name" :disabled="true" />
        </el-form-item>
        <el-form-item label="类型" style="margin-right:15px">
          <el-select v-model="form.type" style="width: 100%" :disabled="true">
            <el-option v-for="item in typeList" :key="item.code" :label="item.name" :value="item.code" />
          </el-select>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import request from '@/utils/request'
export default {
  name: 'UnitDetail',
  data() {
    return {
      emptyForm: {},
      form: {
        code: '',
        name: '',
        type: ''
      },
      // 所属类型
      typeList: []
    }
  },
  created() {
    this.findTypeList()
    // 保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form))
  },
  methods: {
    // 查询类型
    findTypeList() {
      request({ url: `/ntocc-basic-api/dict`, method: 'get', params: { type: 'unitType' }}).then(response => {
        this.typeList = response.data.records
      })
    },
    // 获取页面信息
    getInfo(code) {
      // 查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm))
      request({ url: `/ntocc-basic-api/unit/${code}`, method: 'get' }).then(response => {
        this.form = response.data
        const item = this.typeList.find(item => Number(item.code) === this.form.type)
        this.form.type = item.name
      })
    }
  }
}
</script>
<style lang="scss" scoped>
    .dialog-footer {
        margin-top: 50px;
    }
</style>
